// The rounds endpoint needs the page behind a customized tournament results
// widget to rebuild that page's round list (its entries carry event_ids), and
// the widget document's own query string is where the page id lives: every
// customized widget URL carries page_id (application_controller
// iframe_link_for_website_page). Plain and manager pages use roundsUrl as is.

export const isCustomizedRoundList = (roundList = []) =>
  roundList.some((round) => Array.isArray(round.event_ids));

// null means "nothing to fetch": no endpoint, or a customized list whose page
// id is not in the document's query string (the stored list is then kept).
export function buildRoundsUrl(roundsUrl, roundList = [], search = window.location.search) {
  if (!roundsUrl) return null;
  if (!isCustomizedRoundList(roundList)) return roundsUrl;

  const pageId = new URLSearchParams(search).get('page_id');
  if (!pageId) return null;

  const params = new URLSearchParams({ page_id: pageId });
  return `${roundsUrl}${roundsUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
